/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/*Custom JS*/
document.addEventListener('click', function (e) {
  // Button / Close zuverlässig finden (auch wenn man aufs SVG klickt)
  const openBtn = e.target.closest('[data-menu-open]');
  const closeBtn = e.target.closest('[data-menu-close]');

  // Öffnen
  if (openBtn) {
    // Drawer innerhalb derselben Section suchen
    const root = openBtn.closest('.menu-combo');
    if (!root) return;

    // Optional: über aria-controls gezielt die Drawer-ID nutzen
    const drawerId = openBtn.getAttribute('aria-controls');
    const drawer = drawerId
      ? root.querySelector('#' + CSS.escape(drawerId))
      : root.querySelector('[data-menu-drawer]');

    if (!drawer) return;

    drawer.classList.add('is-open');
    openBtn.setAttribute('aria-expanded', 'true');
    return;
  }

  // Schließen (Overlay oder X)
  if (closeBtn) {
    const root = closeBtn.closest('.menu-combo');
    if (!root) return;

    const drawer = closeBtn.closest('[data-menu-drawer]') || root.querySelector('[data-menu-drawer]');
    if (!drawer) return;

    drawer.classList.remove('is-open');

    const trigger = root.querySelector('[data-menu-open]');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    return;
  }

  // Side submenu toggles
  const toggle = e.target.closest('[data-side-toggle]');
  if (toggle) {
    const item = toggle.closest('.side-item');
    if (!item) return;

    const expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!expanded));
    item.classList.toggle('is-open');
  }
});



(function () {
  const MQ = window.matchMedia('(max-width: 1023px)');

  function initOne(track) {
    if (!MQ.matches) return;
    if (track.dataset.loopInit === 'true') return;

    const slides = Array.from(track.querySelectorAll('.mosaic-mobile-slide')).filter(s => !s.hasAttribute('data-clone'));
    if (slides.length <= 1) return;

    track.dataset.loopInit = 'true';

    // Clone first + last for seamless loop
    const firstClone = slides[0].cloneNode(true);
    const lastClone  = slides[slides.length - 1].cloneNode(true);
    firstClone.setAttribute('data-clone', 'true');
    lastClone.setAttribute('data-clone', 'true');

    track.appendChild(firstClone);
    track.insertBefore(lastClone, track.firstChild);

    const step = () => track.clientWidth; // 1 slide = 100% viewport width
    track.scrollLeft = step();            // start at first real slide

    let pausedUntil = 0;
    let animating = false;

    function normalize() {
      const w = step();
      const realCount = slides.length;
      const idx = Math.round(track.scrollLeft / w);

      if (idx === 0) track.scrollLeft = realCount * w;      // lastClone -> last real
      if (idx === realCount + 1) track.scrollLeft = w;      // firstClone -> first real
    }

    function next() {
      if (!MQ.matches) return;
      if (animating) return;
      if (Date.now() < pausedUntil) return;

      animating = true;
      track.scrollTo({ left: track.scrollLeft + step(), behavior: 'smooth' });

      window.setTimeout(() => {
        normalize();
        animating = false;
      }, 450);
    }

    function pause(ms = 5000) {
      pausedUntil = Date.now() + ms;
    }

    const timerId = window.setInterval(next, 3000);
    track._loopTimer = timerId;

    // Pause on interaction
    track.addEventListener('touchstart', () => pause(6000), { passive: true });
    track.addEventListener('touchmove',  () => pause(6000), { passive: true });
    track.addEventListener('scroll', () => {
      pause(3000);
      clearTimeout(track._normT);
      track._normT = setTimeout(normalize, 120);
    }, { passive: true });

    // Resize handling (mobile only)
    track._onResize = () => {
      if (!MQ.matches) return;
      track.scrollLeft = track.clientWidth;
      normalize();
    };
    window.addEventListener('resize', track._onResize);
  }

  function initAll() {
    if (!MQ.matches) return;
    document.querySelectorAll('[data-mosaic-mobile-slider]').forEach(initOne);
  }

  function cleanupAll() {
    document.querySelectorAll('[data-mosaic-mobile-slider]').forEach((track) => {
      // remove clones
      track.querySelectorAll('[data-clone="true"]').forEach(n => n.remove());
      // stop timer
      if (track._loopTimer) clearInterval(track._loopTimer);
      track._loopTimer = null;
      // remove resize listener
      if (track._onResize) window.removeEventListener('resize', track._onResize);
      track._onResize = null;

      track.dataset.loopInit = 'false';
      track.scrollLeft = 0;
    });
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);

  // Breakpoint change (Safari fallback)
  if (MQ.addEventListener) {
    MQ.addEventListener('change', (e) => (e.matches ? initAll() : cleanupAll()));
  } else if (MQ.addListener) {
    MQ.addListener((e) => (e.matches ? initAll() : cleanupAll()));
  }
})();

/* ============================================================
 * Jonelia – Produktseite (Buybox, Kombi-Kauf, Sticky-ATC)
 * Alles ueber Delegation am document, damit es <product-rerender>
 * (Warehouse ersetzt die Buybox beim Variantenwechsel) uebersteht.
 * ============================================================ */
(function () {
  'use strict';

  /* ---------- Geldformat ---------- */
  function formatMoney(cents, format) {
    var fmt = format || '€{{amount_with_comma_separator}}';
    function withDelim(num, thousands, decimal) {
      var v = (num / 100).toFixed(2).split('.');
      var int = v[0].replace(/(\d)(?=(\d\d\d)+$)/g, '$1' + thousands);
      return int + decimal + v[1];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case 'amount': return withDelim(cents, ',', '.');
        case 'amount_no_decimals': return String(Math.round(cents / 100));
        case 'amount_with_comma_separator': return withDelim(cents, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return String(Math.round(cents / 100)).replace(/(\d)(?=(\d\d\d)+$)/g, '$1.');
        case 'amount_with_apostrophe_separator': return withDelim(cents, "'", '.');
        default: return withDelim(cents, '.', ',');
      }
    });
  }

  /* ---------- 1. Kaufoptionen ---------- */
  document.addEventListener('change', function (e) {
    var radio = e.target.closest('[data-jon-purchase-options] .jon-po__radio');
    if (!radio) return;
    var box = radio.closest('[data-jon-purchase-options]');
    if (!box) return;

    box.querySelectorAll('[data-jon-po-card]').forEach(function (c) {
      c.classList.toggle('is-selected', c.contains(radio));
    });

    var qtyId = box.getAttribute('data-qty-target');
    var qty = document.getElementById(qtyId);
    var wanted = radio.getAttribute('data-jon-qty') || '1';
    if (qty) {
      var max = parseInt(qty.getAttribute('max') || '0', 10);
      var val = parseInt(wanted, 10) || 1;
      if (max > 0 && val > max) val = max;
      qty.value = String(val);
      qty.dispatchEvent(new Event('change', { bubbles: true }));
    }

    /* Abo-Plaene nur aktivieren, wenn die Abo-Option gewaehlt ist */
    var subWrap = box.querySelector('[data-jon-sub-plans]');
    if (subWrap) {
      var isSub = !!radio.hasAttribute('data-jon-sub');
      subWrap.hidden = !isSub;
      subWrap.querySelectorAll('input[name="selling_plan"]').forEach(function (i) {
        i.disabled = !isSub;
      });
    }
  });

  function mainProductForm(bundle) {
    return Array.from(document.querySelectorAll('form.product-form')).find(function (form) {
      return form.getAttribute('id') === bundle.dataset.formId ||
        (form.getAttribute('id') || '').indexOf('product-form-main-' + bundle.dataset.productId + '-') === 0;
    });
  }

  function fbtTotal(bundle) {
    var main = mainProductForm(bundle);
    var quantity = Math.max(1, Number(main && main.elements.namedItem('quantity')?.value) || Number(bundle.dataset.baseQuantity) || 1);
    bundle.dataset.baseQuantity = String(quantity);
    var total = Number(bundle.dataset.basePrice) * quantity;
    bundle.querySelectorAll('[data-jon-fbt-item]:checked').forEach(function (item) {
      total += Number(item.dataset.price) * (Number(item.dataset.quantity) || 1);
    });
    bundle.querySelector('[data-jon-fbt-total]').textContent = formatMoney(total, bundle.dataset.currencyFormat);
    var qty = bundle.querySelector('[data-jon-fbt-base-quantity]');
    if (qty) qty.textContent = quantity + ' ×';
    var plan = main && main.elements.namedItem('selling_plan')?.value;
    var button = bundle.querySelector('[data-jon-fbt-add]');
    button.disabled = bundle.dataset.busy === 'true' || bundle.dataset.baseAvailable !== 'true' || !!plan;
    if (plan) {
      var hint = bundle.querySelector('[data-jon-fbt-hint]');
      hint.hidden = false;
      hint.textContent = bundle.dataset.planNote;
      hint.dataset.plan = 'true';
    } else {
      var hint = bundle.querySelector('[data-jon-fbt-hint]');
      if (hint.dataset.plan) { hint.hidden = true; delete hint.dataset.plan; }
    }
  }

  function initBundles() { document.querySelectorAll('[data-jon-fbt]').forEach(fbtTotal); }
  document.addEventListener('DOMContentLoaded', initBundles);
  document.addEventListener('shopify:section:load', initBundles);
  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-jon-fbt-item], [name="quantity"], [name="selling_plan"]')) initBundles();
  });
  document.addEventListener('variant:changed', function (event) {
    var variant = event.detail && event.detail.variant;
    document.querySelectorAll('[data-jon-fbt]').forEach(function (bundle) {
      var main = mainProductForm(bundle);
      if (!main || event.target !== main) return;
      bundle.dataset.baseAvailable = String(!!variant?.available);
      bundle.dataset.baseVariant = variant?.id ? String(variant.id) : '';
      bundle.dataset.basePrice = String(variant?.price || 0);
      var title = bundle.querySelector('[data-jon-fbt-base-variant]');
      if (title) title.textContent = variant?.title === 'Default Title' ? '' : (variant?.title || '');
      requestAnimationFrame(function () { fbtTotal(bundle); });
    });
  });
  document.addEventListener('click', async function (event) {
    var button = event.target.closest('[data-jon-fbt-add]');
    if (!button || button.disabled) return;
    var bundle = button.closest('[data-jon-fbt]');
    fbtTotal(bundle);
    if (button.disabled) return;
    var main = mainProductForm(bundle);
    if (!main || !main.reportValidity()) return;
    var currentId = main.elements.namedItem('id')?.value;
    if (!currentId || currentId !== bundle.dataset.baseVariant) return;
    var items = [{ id: currentId, quantity: Number(bundle.dataset.baseQuantity) }];
    bundle.querySelectorAll('[data-jon-fbt-item]:checked').forEach(function (item) {
      items.push({ id: item.dataset.variantId, quantity: Number(item.dataset.quantity) || 1 });
    });
    var hint = bundle.querySelector('[data-jon-fbt-hint]');
    bundle.dataset.busy = 'true';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    hint.hidden = true;
    try {
      var response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      });
      var result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || bundle.dataset.error);
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      hint.textContent = bundle.dataset.success;
    } catch (error) {
      hint.textContent = bundle.dataset.error + ' ' + error.message;
    } finally {
      hint.hidden = false;
      bundle.dataset.busy = 'false';
      button.removeAttribute('aria-busy');
      fbtTotal(bundle);
    }
  });

  /* ---------- 3. Mobile Sticky-Buybox ---------- */
  var stickyObserver = null;

  function initSticky() {
    var bar = document.querySelector('[data-jon-sticky-atc]');
    if (!bar) return;
    var formId = bar.getAttribute('data-form-id');
    var form = formId ? document.getElementById(formId) : null;
    if (!form) return;
    var anchor = form.querySelector('button[type="submit"]');
    if (!anchor) return;

    if (stickyObserver) stickyObserver.disconnect();
    stickyObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.hidden = entry.isIntersecting;
      });
    }, { rootMargin: '0px 0px -40px 0px' });
    stickyObserver.observe(anchor);
  }

  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-jon-sticky-add]');
    if (!add) return;
    var bar = add.closest('[data-jon-sticky-atc]');
    var form = bar && document.getElementById(bar.getAttribute('data-form-id'));
    if (!form) return;
    var nativeButton = form.querySelector('button[type="submit"]');
    if (!nativeButton || nativeButton.disabled || add.disabled) return;
    e.preventDefault();
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      var submit = form.querySelector('button[type="submit"]');
      if (submit) submit.click();
    }
  });

  document.addEventListener('variant:changed', function (event) {
    var variant = event.detail && event.detail.variant;
    var bar = document.querySelector('[data-jon-sticky-atc]');
    if (bar && event.target.getAttribute('id') !== bar.dataset.formId) return;
    if (!bar) return;
    if (!variant || !variant.id) { var unavailable = bar.querySelector('[data-jon-sticky-add]'); if (unavailable) { unavailable.disabled = true; unavailable.textContent = window.languages.productFormUnavailable; } initSticky(); return; }

    var priceEl = bar.querySelector('[data-jon-sticky-price]');
    if (priceEl) {
      priceEl.textContent = formatMoney(variant.price,
        (window.theme && window.theme.moneyFormat) || '{{amount_with_comma_separator}} €');
    }
    var varEl = bar.querySelector('[data-jon-sticky-variant]');
    if (varEl && variant.title && variant.title !== 'Default Title') varEl.textContent = variant.title;

    var addBtn = bar.querySelector('[data-jon-sticky-add]');
    if (addBtn) {
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available ? window.languages.productFormAddToCart : window.languages.productFormSoldOut;
    }
    window.setTimeout(initSticky, 60);
  });

  document.addEventListener('DOMContentLoaded', initSticky);
  document.addEventListener('shopify:section:load', initSticky);
  window.setTimeout(initSticky, 300);
})();


document.addEventListener('click', async event => {
  const button = event.target.closest('[data-jon-cart-add]');
  if (!button || button.disabled) return;
  const region = button.closest('.jon-cart-offers');
  const status = region.querySelector('[role="status"]');
  const original = button.textContent;
  button.disabled = true;
  button.textContent = region.dataset.loading;
  status.textContent = '';
  try {
    if (button.dataset.discountCode) {
      const cartResponse = await fetch(region.dataset.cartUrl, {credentials:'same-origin',headers:{'Accept':'application/json'}});
      if (!cartResponse.ok) throw new Error(region.dataset.error);
      const currentCart = await cartResponse.json();
      const codes = (currentCart.discount_codes || []).map(entry => entry.code);
      if (!codes.some(code => code.toUpperCase() === button.dataset.discountCode.toUpperCase())) codes.push(button.dataset.discountCode);
      const discountResponse = await fetch(region.dataset.updateUrl, {
        method:'POST', credentials:'same-origin',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({discount:codes.join(',')})
      });
      if (!discountResponse.ok) throw new Error(region.dataset.error);
    }
    const response = await fetch(region.dataset.addUrl, {
      method: 'POST', credentials: 'same-origin',
      headers: {'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({items:[{id:Number(button.dataset.jonCartAdd),quantity:Number(button.dataset.quantity)||1}]})
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || region.dataset.error);
    button.textContent = region.dataset.added;
    status.textContent = region.dataset.added;
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true,detail:{scrollToTop:false}}));
  } catch (error) {
    status.textContent = error.message || region.dataset.error;
    button.textContent = original;
    button.disabled = false;
  }
});

